import * as React from 'react';
import EmojiPicker, { EmojiClickData, EmojiStyle, Theme } from 'emoji-picker-react';
import { Button } from '@/shadcn/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@/shadcn/components/ui/dialog';

interface IProps {
  onEmojiSelect: (emoji: string) => void;
  disabled?: boolean;
}

export const EmojiPickerSingle: React.FC<IProps> = ({ onEmojiSelect, disabled = false }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleEmojiClick = React.useCallback((emojiData: EmojiClickData) => {
    onEmojiSelect(emojiData.emoji);
    // Don't close the modal - allow multiple emoji selection
  }, [onEmojiSelect]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={disabled}
          aria-label="Insert emoji"
          title="Insert emoji"
        >
          😀
        </Button>
      </DialogTrigger>
      <DialogContent
        className="w-auto max-w-none p-0 border-0 bg-transparent shadow-none !z-[99999] [&>button]:hidden"
        onInteractOutside={() => setIsOpen(false)}
      >
        <div className="rounded-lg border bg-white shadow-xl">
          <EmojiPicker
            onEmojiClick={handleEmojiClick}
            emojiStyle={EmojiStyle.NATIVE}
            theme={Theme.LIGHT}
            previewConfig={{
              showPreview: false
            }}
            width={300}
            height={350}
            searchDisabled={false}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
